package com.esoris.kmpmoout.domaindata.expense

import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.from
import io.github.jan.supabase.postgrest.query.Order
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlin.String
import kotlin.collections.List
import kotlin.collections.emptyList
import kotlin.collections.filter
import kotlin.collections.filterNot
import kotlin.collections.listOf
import kotlin.collections.map
import kotlin.collections.plus
import kotlin.map
import kotlin.sequences.filter
import kotlin.sequences.map
import kotlin.text.filter
import kotlin.text.insert
import kotlin.text.map

class ExpenseRepositoryImpl(
    private val supabase: SupabaseClient
) : ExpenseRepository {

    private val _expenses =
        MutableStateFlow<List<Expense>>(emptyList())

    override val expenses: StateFlow<List<Expense>>
            = _expenses.asStateFlow()

    override suspend fun loadExpenses() {

        val result = supabase
            .from("expenses")
            .select {
                order(
                    column = "created_at",
                    order = Order.DESCENDING
                )
            }
            .decodeList<ExpenseDto>()

        _expenses.value =
            result.map { it.toExpense() }
    }

    override suspend fun insertExpense(
        expense: Expense
    ) {

        supabase
            .from("expenses")
            .insert(expense.toDto())

        _expenses.update {
            listOf(expense) + it
        }
    }

    override suspend fun deleteExpenseById(
        id: String
    ) {

        supabase
            .from("expenses")
            .delete {
                filter {
                    eq("id", id)
                }
            }

        _expenses.update { list ->
            list.filterNot {
                it.id == id
            }
        }
    }
}